import React, { useState, useEffect } from 'react';
import './styles.css';

const MobileExperience = ({ isDarkMode }) => {
    const [experienceData, setExperienceData] = useState([]);

    useEffect(() => {
        fetch('/data/experience.json')
            .then(response => response.json())
            .then(data => {
                const experiences = data.filter(item => item.type !== 'education').sort((a, b) => b.id - a.id);
                setExperienceData(experiences);
            })
            .catch(error => console.error('Error fetching experience data:', error));
    }, []);

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Experience</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    <div className="mobile-timeline">
                        {experienceData.map((exp, index) => (
                            <div key={index} className="mobile-card">
                                <div className="mobile-card-header">
                                    <h3 className="mobile-card-title">{exp.title}</h3>
                                    <span className="mobile-card-period">{exp.period}</span>
                                </div>
                                <p className="mobile-card-subtitle">{exp.location}</p>
                                <p className="mobile-card-description">{exp.description}</p>
                                {exp.technologies && exp.technologies.length > 0 && (
                                    <div className="mobile-tech-list">
                                        {exp.technologies.map((tech, techIndex) => (
                                            <span key={techIndex} className="mobile-tech-item">{tech}</span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileExperience;
